module.exports = __webpack_public_path__ + "static/img/partner-kingfa.59ce754.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-kingfa.png
// module id = C+Mq
// module chunks = 34